// Reconstructed from production code; original paths and local names were not available.
import { Link } from "react-router-dom";
import { MEDIA_BASE_URL } from "../services/config.js";
import { Seo } from "../components/Seo.jsx";
import * as jsxRuntime from "react/jsx-runtime";
import { useCart } from "../context/CartContext.jsx";
import { useLanguage } from "../context/LanguageContext.jsx";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../context/ThemeContext.jsx";
function CartPage() {
  const navigate = useNavigate(),
    location = useLocation(),
    { theme: theme } = useTheme(),
    { t: t, tProd: tProd, tText } = useLanguage(),
    {
      items: items,
      total: total,
      loading: loading,
      error: error,
      updateItemQuantity: updateItemQuantity,
      removeItem: removeItem,
    } = useCart(),
    x = (N, T) => {
      T < 0 || updateItemQuantity(N.id, T).catch(() => {});
    },
    O = () => {
      items.length && navigate("/checkout");
    },
    H = theme?.site_name || "MyShop",
    E = items.some((N) => N.out_of_stock),
    M = items.length === 0 || E;
  return (
    <div className={"cart-page"}>
      <Seo
        title={t("cartTitle")}
        description={tText("Review the items in your cart before checkout.")}
        image={theme?.logo || null}
        urlPath={location.pathname}
        type={"website"}
        siteName={H}
        noindex={true}
      />
      <h1 className={"cart-title"}>{t("yourCart")}</h1>
      {error && (
        <div className={"cart-alert-error"} role={"alert"}>
          {tText(error)}
        </div>
      )}
      <div className={"cart-layout"}>
        <section className={"cart-items-card"} aria-busy={loading}>
          {loading && (
            <p className={"cart-muted cart-updating-status"} role={"status"}>
              {t("updatingCart")}
            </p>
          )}
          {items.length === 0 && !loading && (
            <p className={"cart-muted"}>
              {t("cartEmpty")}
              {"   "}
              <Link to={"/"}>{t("browseProducts")}</Link>
            </p>
          )}
          {items.map((N) => {
            const T = N.variant_image_url || N.product_image_url,
              Y = T
                ? T.startsWith("http")
                  ? T
                  : `${MEDIA_BASE_URL}${T}`
                : null;
            return (
              <div
                className={"cart-item" + (Y ? "" : " cart-item--without-image")}
                key={N.id}
              >
                {Y && (
                  <img
                    src={Y}
                    alt={tProd(N.product_name)}
                    className={"cart-item-img"}
                    loading={"lazy"}
                    decoding={"async"}
                  />
                )}
                <div className={"cart-item-info"}>
                  <h3 className={"cart-item-title"}>{tProd(N.product_name)}</h3>
                  {N.variant_name && (
                    <div className={"cart-item-variant"}>
                      {t("variant")}
                      {": "}
                      <span>{tProd(N.variant_name)}</span>
                    </div>
                  )}
                  {N.short_description && (
                    <p className={"cart-item-desc"}>
                      {tProd(N.short_description, N, "short_description")}
                    </p>
                  )}
                  <div className={"cart-item-footer"}>
                    {N.out_of_stock && (
                      <p className={"cart-item-stock-status"} role={"status"}>
                        {t("productOutOfStock") || tText("Out of stock")}
                      </p>
                    )}
                    <div className={"cart-qty-control"}>
                      <button
                        type={"button"}
                        onClick={() => x(N, N.quantity - 1)}
                        aria-label={`${t("quantity")} - ${tProd(N.product_name)}`}
                      >
                        <span aria-hidden={"true"}>{"−"}</span>
                      </button>
                      <input
                        type={"number"}
                        value={N.quantity}
                        min={0}
                        inputMode={"numeric"}
                        aria-label={`${t("quantity")} ${tProd(N.product_name)}`}
                        onChange={($) => x(N, Number($.target.value) || 0)}
                      />
                      <button
                        type={"button"}
                        onClick={() => x(N, N.quantity + 1)}
                        aria-label={`${t("quantity")} + ${tProd(N.product_name)}`}
                      >
                        <span aria-hidden={"true"}>{"+"}</span>
                      </button>
                    </div>
                    <div className={"cart-item-prices"}>
                      <span className={"cart-unit-price"}>
                        {N.unit_price.toFixed(2)}
                        {" OMR"}
                      </span>
                      <span className={"cart-line-total"}>
                        {(N.line_total || N.unit_price * N.quantity).toFixed(2)}{" "}
                        {"OMR"}
                      </span>
                    </div>
                  </div>
                  <button
                    type={"button"}
                    className={"cart-remove-btn"}
                    onClick={() => removeItem(N.id).catch(() => {})}
                    aria-label={`${t("remove")} ${tProd(N.product_name)}`}
                  >
                    {t("remove")}
                  </button>
                </div>
              </div>
            );
          })}
        </section>
        <aside className={"cart-summary-card"} aria-label={t("orderSummary")}>
          <h2>{t("orderSummary")}</h2>
          <div className={"cart-summary-row"}>
            <span>{t("subtotal")}</span>
            <span>
              {total.toFixed(2)}
              {" OMR"}
            </span>
          </div>
          <div className={"cart-summary-row cart-summary-row-muted"}>
            <span>{t("shipping")}</span>
            <span>{t("calculatedLater")}</span>
          </div>
          <div className={"cart-summary-row cart-summary-row-strong"}>
            <span>{t("total")}</span>
            <span>
              {total.toFixed(2)}
              {" OMR"}
            </span>
          </div>
          <button
            type={"button"}
            className={"cart-checkout-btn"}
            disabled={M}
            onClick={O}
          >
            {t("proceedToCheckout")}
          </button>
          <p className={"cart-summary-note"}>{t("checkoutNote")}</p>
        </aside>
      </div>
      <div
        className={"cart-mobile-checkout-bar"}
        aria-label={t("orderSummary")}
      >
        <div className={"cart-mobile-checkout-bar__total"}>
          <span>{t("total")}</span>
          <strong>
            {total.toFixed(2)}
            {" OMR"}
          </strong>
        </div>
        <button
          type={"button"}
          className={"cart-checkout-btn"}
          disabled={M}
          onClick={O}
        >
          {t("proceedToCheckout")}
        </button>
      </div>
    </div>
  );
}
export { CartPage };
